import { createUseStyles } from "react-jss";

/**
 * Styles for the edit user page
 */
export const userEditUserPageStyles = createUseStyles({
  mainContentCls: {
    padding: "2em"
  },
  titleCls: {
    fontSize: "20px",
    fontWeight: "bold"
  }
});
